import { List as IList, Map as IMap } from 'immutable';
import shippingMessages, { maybeGetDisplayName } from './shippingMessages';
import { getFormattedAmountWithCurrency } from '../utils/numberUtils';

export const getShippingCostDisplay = (cost, intl, currencyCode) => (
    parseFloat(cost) === 0
        ? intl.formatMessage(shippingMessages.free)
        : getFormattedAmountWithCurrency(intl, cost, currencyCode, true)
);

export const getShippingOptionText = (intl, shippingMethod) => {
    if (!shippingMethod) {
        return intl.formatMessage(shippingMessages.noneSelected);
    }
    const {
        cost, carrier, methodName, displayName, currencyCode
    } = shippingMethod.toJS();

    const displayCost = getShippingCostDisplay(cost, intl, currencyCode);
    const maybeDisplayName = maybeGetDisplayName(carrier, methodName);
    const displayText = maybeDisplayName ? `${intl.formatMessage(maybeDisplayName.toJS())}` : `${displayName}`;

    return `${displayCost} ${displayText}`;
};


export default {
    getShippingOptionText
};


export const promoShippingCost = (shippingState, promoData) => {
    const methods = shippingState.withMutations((state1) => {
        state1.keySeq().forEach((profileKey) => {
            const methodsList = state1.getIn([profileKey, 'methods'], IList([]));
            if (methodsList && methodsList.map && methodsList.size > 0) {
                const updatedMethods = methodsList.map((method) => {
                    const token = method.get('token');
                    if (promoData && promoData.get(token)) {
                        const cartTokens = promoData.get(token, IMap({})).get('cartTokens', IList([]));
                        if (cartTokens.size > 0) {
                            return method.set('cost', promoData.get(token).get('updatedCost'));
                        }
                    }
                    return method;
                });
                state1.updateIn([profileKey, 'methods'], [], () => updatedMethods);
            }
        });
    });
    return methods;
};

export const promoShippingCostWithData = (methods, promoData) => {
    const tempDict = {};

    const methodsList = methods || IList([]);
    if (methodsList && methodsList.length > 0) {
        methodsList.forEach((method) => {
            const { token, cost } = method;
            if (promoData && promoData.get(token)) {
                const cartTokens = promoData.get(token, IMap({})).get('cartTokens', IList([]));
                if (cartTokens.size > 0) {
                    tempDict[token] = {
                        actualCost: cost,
                        updatedCost: promoData.get(token).get('updatedCost')
                    };
                }
            }
        });
    }

    return tempDict;
};
